import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Shield, Mail, Lock, Loader2 } from "lucide-react";
import { useSuperAdmin } from "./SuperAdminContext";

const API = "https://api.komorotel.com/api/superadmin";

export default function SuperAdminLogin() {
  const navigate = useNavigate();
  const { refetch } = useSuperAdmin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email || !password) return setError("Email et mot de passe requis.");
    setLoading(true);
    setError(null);
    try {
      await axios.post(`${API}/login`, { email, password }, { withCredentials: true });
      refetch();
      navigate("/superadmin");
    } catch (err) {
      setError(err.response?.data?.message || "Erreur de connexion.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f9fafb] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">

        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-2xl bg-gray-900 flex items-center justify-center mb-4">
            <Shield className="text-white" size={22} />
          </div>
          <h1 className="text-xl font-semibold text-gray-900 tracking-tight">Super Admin</h1>
          <p className="text-sm text-gray-400 mt-1">Console d'administration Komorotel</p>
        </div>

        <div className="bg-white border border-[#e5e7eb] rounded-2xl p-6 shadow-sm">
          <div className="flex flex-col gap-4">

            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1.5">Email</label>
              <div className="relative">
                <Mail size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && handleSubmit()}
                  placeholder="admin@komorotel.com"
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-[#e5e7eb] rounded-xl outline-none focus:border-[#3A9D23] focus:ring-2 focus:ring-[#3A9D23]/10 transition"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1.5">Mot de passe</label>
              <div className="relative">
                <Lock size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && handleSubmit()}
                  placeholder="••••••••"
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-[#e5e7eb] rounded-xl outline-none focus:border-[#3A9D23] focus:ring-2 focus:ring-[#3A9D23]/10 transition"
                />
              </div>
            </div>

            {error && (
              <p className="text-xs text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</p>
            )}

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="w-full py-2.5 bg-[#3A9D23] text-white text-sm font-medium rounded-xl hover:bg-[#2d8019] transition disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 size={15} className="animate-spin" />}
              Se connecter
            </button>
          </div>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          Accès réservé aux administrateurs de la plateforme
        </p>
      </div>
    </div>
  );
}
